import type { Story } from '@/store/story-types'

export const TECH_REVIEW_STORE_STORY: Story = {
  id: 'tech-review-store',
  name: 'Tech Review Store',
  narrative:
    'A tech review and recommendation store with detailed spec comparisons, featured reviews, and curated product picks for tech enthusiasts.',
  goals: [
    'Showcase featured tech reviews with ratings',
    'Present spec comparison tables for products',
    'Drive affiliate purchases through recommendations',
    'Build authority with in-depth review content',
  ],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home',
      title: 'Home',
      order: 0,
      status: 'draft',
      elementCount: 3,
      linkedPageId: 'home',
      description:
        'Landing page with hero banner, featured reviews grid, and comparison table',
      blockRef: { category: 'store', blockId: 'tech-hero' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-browse-reviews',
      name: 'Browse Featured Reviews',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'the page loads' },
        {
          type: 'then',
          text: 'the tech hero banner and featured reviews grid are visible',
          linkedPageId: 'home',
        },
      ],
    },
    {
      id: 'bdd-compare-specs',
      name: 'Compare Product Specs',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'the visitor scrolls to the comparison table' },
        {
          type: 'then',
          text: 'the spec comparison table with product details and ratings is displayed',
          linkedPageId: 'home',
        },
      ],
    },
    {
      id: 'bdd-click-recommendation',
      name: 'Click Product Recommendation',
      steps: [
        { type: 'given', text: 'the visitor is viewing a featured review' },
        { type: 'when', text: 'the visitor taps "Buy Now" on a recommended product' },
        {
          type: 'then',
          text: 'the visitor is directed to the product purchase page',
          linkedPageId: 'home',
        },
      ],
    },
  ],
}
